module.exports = __webpack_public_path__ + "img/7.4fcd6265.png";